import React from "react";
import styles from "./TopHeader.module.css";
import { AppBar, Toolbar, Typography, Button, Switch } from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import { useNavigate } from "react-router-dom";

const TopHeader = () => {
  const navigate = useNavigate()
  return (
    <AppBar position="static" className={styles.header}>
      <Toolbar className={styles.toolbar}>
        {/* Website Logo and Name */}
        <Typography variant="h6" className={styles.logo} onClick={()=>navigate("/dashboard")}>
          Remini
        </Typography>

        <div className={styles.rightSection}>
          {/* Upgrade Button */}
          <Button variant="contained" className={styles.upgradeButton}>
            Upgrade
          </Button>

          {/* Dark Mode Toggle (Optional) */}
          <div className={styles.toggleContainer}>
            <Brightness4Icon className={styles.icon} />
            <Switch defaultChecked className={styles.switch} />
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default TopHeader;
